export default __webpack_public_path__ + "static/media/insta.634743b2.svg";